import { t } from "@travily/i18n";
import { Radio, RadioGroup } from "@ui/primitives/RadioGroup";
import { useState } from "react";
import StarEmptyIcon from "./assets/star-empty.svg?react";
import StarFilledIcon from "./assets/star-filled.svg?react";

const STARS = [1, 2, 3, 4, 5] as const;

export interface RatingInputProps {
  "aria-labelledby"?: string;
  value: number | null;
  onChange: (value: number) => void;
}

export function RatingInput({ "aria-labelledby": labelledBy, value, onChange }: RatingInputProps) {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const activeIndex = hoveredIndex ?? value;

  return (
    <RadioGroup
      aria-label={labelledBy ? undefined : t("components.views.products.review_modal.rating_label")}
      aria-labelledby={labelledBy}
      className="flex items-center"
      onChange={(v) => onChange(Number(v))}
      orientation="horizontal"
      value={value?.toString() ?? null}
    >
      {STARS.map((star) => (
        <Radio
          key={star}
          aria-label={t("components.views.products.rating_input.star_count", { count: star })}
          className="cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-neutral-400 rounded-full"
          onPointerEnter={() => setHoveredIndex(star)}
          onPointerLeave={() => setHoveredIndex(null)}
          value={star.toString()}
        >
          {activeIndex != null && star <= activeIndex ? (
            <StarFilledIcon aria-hidden="true" className="size-12" />
          ) : (
            <StarEmptyIcon aria-hidden="true" className="size-12" />
          )}
        </Radio>
      ))}
    </RadioGroup>
  );
}
